import { useMemo } from 'react';
import { useAuthStore } from '@/features/auth/store/auth-store';

export function useAuth() {
  const user = useAuthStore((s) => s.user);
  const status = useAuthStore((s) => s.status);
  const tempToken = useAuthStore((s) => s.tempToken);
  return { user, status, tempToken };
}

/** Permisos efectivos del usuario actual como Set<string>. */
export function usePermissions(): Set<string> {
  const user = useAuthStore((s) => s.user);
  return useMemo(() => new Set(user?.permisos ?? []), [user]);
}